import React from 'react';
import { motion } from 'framer-motion';
const values = [{
  name: 'AMIGURUMIS',
  count: '1200+ patrones',
  price: '$29.990'
}, {
  name: 'BEBÉS Y NIÑOS',
  count: '850+ patrones',
  price: '$24.990'
}, {
  name: 'TOPS Y BLUSAS',
  count: '600+ patrones',
  price: '$24.990'
}, {
  name: 'DECO HOGAR',
  count: '500+ patrones',
  price: '$24.990'
}, {
  name: 'SWEATERS Y CARDIGANS',
  count: '450+ patrones',
  price: '$29.990'
}, {
  name: 'ACCESORIOS',
  count: '400+ patrones',
  price: '$19.990'
}, {
  name: 'PATRONES EXTRA',
  count: 'Varios',
  price: '$19.990'
}];
export function Value() {
  return <section className="py-14 px-6 bg-white" data-id="element-271">
      <div className="max-w-3xl mx-auto" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-273">
          <h2 className="text-2xl md:text-4xl font-bold text-dark mb-2 leading-tight" data-id="element-274">
            ¿CUÁNTO TE COSTARÍA COMPRAR TODO ESTO{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-275">
              POR SEPARADO?
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-276">
          {values.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="flex justify-between items-center bg-cream/20 border border-rose-light/30 p-4 rounded-xl shadow-sm" data-id="element-277">
              <div className="flex flex-col" data-id="element-278">
                <span className="text-base font-bold text-dark" data-id="element-279">
                  {item.name}
                </span>
                <span className="text-xs text-dark/60 font-medium" data-id="element-280">
                  {item.count}
                </span>
              </div>
              <span className="text-lg font-bold text-dark/40 line-through decoration-rose-light" data-id="element-281">
                {item.price}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-between items-center py-4 border-t-2 border-dark/10 mb-8 px-2" data-id="element-282">
          <span className="text-xl font-bold text-dark" data-id="element-283">TOTAL:</span>
          <span className="text-2xl font-bold text-dark/40 line-through decoration-rose-deep/50" data-id="element-284">
            $173.930 ARS
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-rose-deep to-rose-dark rounded-2xl p-6 md:p-8 text-center shadow-premium border border-rose-light/30 relative overflow-hidden text-white" data-id="element-285">
          <div className="absolute top-0 left-0 w-full h-1 bg-gold-light" data-id="element-286"></div>
          <p className="text-sm md:text-base font-bold text-white/80 uppercase tracking-widest mb-2" data-id="element-287">
            Oferta Especial
          </p>
          <p className="text-xl md:text-2xl font-medium mb-2" data-id="element-288">
            HOY ACCEDÉS A TODO POR SOLO
          </p>
          <p className="text-5xl md:text-6xl font-bold text-white mb-2 drop-shadow-md" data-id="element-289">
            $19.990{' '}
            <span className="text-2xl text-white/70 font-normal" data-id="element-290">ARS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}